import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import { useContext } from 'react';
import { store } from 'components/Store';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useSiteSectionsNames } from 'utils/getAppSite';

const TopicItem = (props) => {
  const {
    item,
    applyTopic,
    index,
    startMoveLists,
    setListPosition,
    listPosition,
    setStartMoveLists,
    topic,
    selectedTopic,
    searchValue,
    showTopicSelected,
    alwaysShowSelectedMark = false,
    showMasterTopicIcon = false,
    showActions = true,
    setLocalURLState,
  } = props;
  const isMobile = useIsMobile();
  const location = useLocation();
  const params = useParams();

  const { event } = params;

  const globalState = useContext(store);
  const { state } = globalState;
  const { team } = state;
  const { myself } = team ?? {};
  const { transformTopicOrClientWord, topicOrClientWord, agencyUser } = useTopicOrClientWord();
  const { getTopicTitle } = useSiteSectionsNames();
  const { localURL } = setLocalURLState ?? {};
  const selectedTopicToUse = selectedTopic ?? topic;

  return (
    <div
      className={`${startMoveLists && listPosition === index ? 'dropdown-keywordlist-highlighted' : ''}`}
      onClick={() => {
        applyTopic({ topic: item });
      }}
      onMouseOver={() => {
        if (!isMobile) {
          if (!startMoveLists) {
            setStartMoveLists(true);
          }
          setListPosition(index);
        }
      }}
    >
      <li
        className={`dropdown-keywordlist d-flex ${
          item.description && item.description.trim() !== '' ? 'dropdown-keywordlist-description' : ''
        }`}
      >
        <span className={showMasterTopicIcon && item.id === null ? 'icon-topics-master icon-topics-master-margin' : 'icon-topics-thin'} />
        <div className='flex-grow-1'>
          <p className='hidden-lines hidden-one-line dropdown-name'>
            {!!event && item.name?.startsWith('All updates')
              ? item.name.replace('updates', 'remarks')
              : getTopicTitle(item.name)}
          </p>
          {item.description && <p className='dropdown-description description-field'>{item.description}</p>}
          {selectedTopicToUse?.id === item.id &&
            (alwaysShowSelectedMark ||
              ((searchValue === '' || location.pathname.startsWith('/analytics/')) &&
                (!!getUrlParam('topic-id', localURL) || showTopicSelected))) && (
              <span className='icon-tick topic-selected-mark' />
            )}
        </div>
        <div className='dropdown-list-actions'>
          {(myself.role === 'Admin' || myself.role === 'Owner' || item.isMyList) && item.id !== null && showActions && (
            <Link
              to={{
                pathname: `/settings/${transformTopicOrClientWord({
                  plural: true,
                })}/${item.id}`,
                search: `returnUrl=${encodeURIComponent(location.pathname)}`,
              }}
              state={{ prevPath: location.pathname }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <button
                className='general-button dropdown-edit-keyword-list flex-centered'
                data-tooltip-content={`Edit this ${topicOrClientWord}${agencyUser ? "'s keywords" : ''}`}
                data-tooltip-id={'general-tooltip'}
                data-tooltip-place={'top'}
                data-tooltip-class-name={'edit-icon-analytics-tooltip'}
              >
                <span className='icon-edit-pencil' />
              </button>
            </Link>
          )}
        </div>
      </li>
    </div>
  );
};

export default TopicItem;
